export const mainPagesEn = [
  {
    id: "Home",
    path: "/",
    title: "Home",
  },
  {
    id: "About Us",
    path: "/about",
    title: "About Us",
  },
  {
    id: "Contact Us",
    path: "/contact",
    title: "Contact Us",
  },
];

export const mainPagesAm = [
  {
    id: "Home",
    path: "/",
    title: "Գլխավոր էջ",
  },
  {
    id: "About Us",
    path: "/about",
    title: "Մեր մասին",
  },
  {
    id: "Contact Us",
    path: "/contact",
    title: "Կոնտակտներ",
  },
];
